import { useState, useRef, useEffect } from "react";
import { Row, Col, Form, Button, Dropdown } from "react-bootstrap";
import { iminioBackend } from "../../api/iminio_provider";
import i18n from "../../plugins/i18n";

function CreateCondominiumForm({ changeView }) {
  let isMounted = false;

  const [isLoading, setLoading] = useState(true);
  const [isSubmitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [message, setMessage] = useState("");
  const [adminList, setAdminList] = useState([]);
  const [systemTypeList, setSystemTypeList] = useState([]);
  const [attachedPhoto, setAttachedPhoto] = useState(null);
  const [attachedFileData, setAttachedFileData] = useState(null);
  const [condominiumSystemsText, setCondominiumSystemsText] = useState(
    "Seleziona Tipologie"
  );

  const nameField = useRef(null);
  const managedByField = useRef("");
  const addressStreetField = useRef("");
  const addressPostalCodeField = useRef("");
  const addressProvinceField = useRef("");
  const addressCityField = useRef("");
  const notesField = useRef("");
  const systemTypeField = useRef([]);
  const timeAvailabilityField = useRef("");
  const contactPersonField = useRef("");
  const thirdpartyResponsableField = useRef("");
  const hasKeysField = useRef("");

  const toggleSystemTypeFromList = async (stypeId) => {
    if (
      !systemTypeField.current ||
      systemTypeField.current?.findIndex((e) => e === stypeId) < 0
    )
      systemTypeField.current?.push(stypeId);
    else
      systemTypeField.current = systemTypeField.current?.filter(
        (e) => e !== stypeId
      );

    if (!systemTypeField.current || systemTypeField.current.length == 0) {
      setCondominiumSystemsText("Nessuno");
    } else {
      let temp = [];
      for (let i = 0; i < systemTypeField.current.length; i++) {
        let found = systemTypeList?.find(
          (e) => parseInt(e.id) === parseInt(systemTypeField.current[i])
        );
        if (found)
          temp.push(i18n.t(`models.condominium.system_type.${found.codename}`));
      }
      setCondominiumSystemsText(temp.join(", "));
    }
  };

  const fetchUserList = async () => {
    let tempAdminList = await iminioBackend
      .list_admin_user_options()
      .catch((e) => console.log(e));
    setAdminList(tempAdminList ? tempAdminList.users : []);
  };

  const fetchSystemTypeList = async () => {
    let response = await iminioBackend
      .list_condominia_system_types({})
      .catch((e) => console.log(e));

    const reordered = [
      ...response.system_types.filter((item) => item.codename !== "other"),
      ...response.system_types.filter((item) => item.codename === "other"),
    ];

    setSystemTypeList(reordered);
  };

  const handleSubmit = async () => {
    setError("");
    setSubmitting(true);
    const newCondominiumData = {
      name: nameField.current.value,
      managed_by_id: managedByField.current.value,
      address_street: addressStreetField.current.value,
      address_postcode: addressPostalCodeField.current.value,
      address_state_province: addressProvinceField.current.value,
      address_city: addressCityField.current.value,
      contact_person_name: contactPersonField.current.value,
      has_keys: hasKeysField.current.value === "Si",
      system_types: systemTypeField.current,
      is_third_party_responsable:
        thirdpartyResponsableField.current.value === "Si",
      time_availability: timeAvailabilityField.current.value,
    };
    await iminioBackend
      .create_condominium(newCondominiumData)
      .then(async (response) => {
        if (attachedFileData != null)
          await iminioBackend
            .attach_file_to_condominium(
              response.condominium.id,
              attachedFileData
            )
            .then((response2) => {})
            .catch((e) => console.log(e));
        if (attachedPhoto != null)
          await iminioBackend
            .attach_photo_to_condominium(response.condominium.id, attachedPhoto)
            .then((response2) => {})
            .catch((e) => console.log(e));
        setMessage(
          i18n
            .t("messages.uploaded_success")
            .replace("{1}", i18n.t("models.condominium.single"))
        );
        setTimeout(() => {
          changeView("condominium");
          setSubmitting(false);
        }, 3600);
      })
      .catch((e) => {
        console.log(e);
        switch (e.response?.data?.status?.code) {
          case "ERR_INVALID_FIELDS":
            let details = e.response.data.details[0];
            if (details.code === "string.empty")
              setError(
                i18n
                  .t("errors.required_field")
                  .replace(
                    "{1}",
                    i18n.t(`models.condominium.fields.${details.field}`)
                  )
              );
            else if (
              [
                "number.base",
                "string.pattern.base",
                "date.base",
                "any.required",
              ].includes(details.code)
            )
              setError(
                i18n
                  .t("errors.invalid_field")
                  .replace(
                    "{1}",
                    i18n.t(`models.condominium.fields.${details.field}`)
                  )
              );
            else setError(i18n.t("errors.unknown"));
            break;
          case "ERR_ALREADY_EXISTS":
            let details2 = e.response.data.details;
            setError(
              `${i18n.t(`models.condominium.fields.${details2.field}`)}: ${
                details2.value
              } ` + i18n.t("errors.already_exists")
            );
            break;
          default:
            setError(i18n.t("errors.unknown"));
            break;
        }
        setSubmitting(false);
      });
  };

  const handleFotoChange = (event) => {
    if (event.target.files.length === 0) return;
    var reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = async function () {
      setAttachedPhoto(reader.result);
    };
    reader.onerror = function (error) {
      setLoading(false);
      console.log(error);
    };
  };

  const handleFileChange = (event) => {
    if (event.target.files.length === 0) return;
    var reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = async function () {
      const dataType = reader.result?.split(";")?.[0]?.split(":")?.[1];
      if (dataType?.toLowerCase() !== "application/pdf") {
        setLoading(false);
        setError(i18n.t("errors.invalid_pdf"));
        setTimeout(() => {
          setError("");
        }, 5600);
        return;
      }
      setAttachedFileData({
        base64: reader.result,
        filename: event.target.files[0].name,
      });
    };
    reader.onerror = function (error) {
      setLoading(false);
      console.log(error);
    };
  };

  useEffect(() => {
    const init = async () => {
      await fetchUserList();
      await fetchSystemTypeList();
      setTimeout(() => {
        setLoading(false);
      }, 300);
    };
    if (isMounted === false) {
      init();
      isMounted = true;
    }
  }, []);

  return (
    <Col xs={12} className="mt-4">
      <Row>
        <Col xs={4} className="d-flex justify-content-start align-items-center">
          <i className="mdi mdi-office-building-plus text-20 fg-orange me-3"></i>
          <h3 className="">Creare Condominio</h3>
        </Col>
      </Row>
      <div className="divider-h mt-2"></div>
      <Row className="p-4">
        <Col xs={12} md={5} className="justify-content-center pe-4">
          <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
            <Form.Label column xs="5" className="text-9">
              Nome Condominio (*)
            </Form.Label>
            <Col xs="7">
              <Form.Control
                type="text"
                ref={nameField}
                disabled={isLoading || isSubmitting}
              />
            </Col>
          </Form.Group>
        </Col>
        <Col xs={12} md={5} className="justify-content-center pe-4">
          <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
            <Form.Label column xs="4" className="text-9">
              Amministratore (*)
            </Form.Label>
            <Col xs="8">
              <Form.Select
                ref={managedByField}
                disabled={isLoading || isSubmitting}
              >
                <option>Seleziona Amministratore</option>
                {isLoading
                  ? ""
                  : adminList.map((e) => {
                      return (
                        <option key={`adminitemsel-${e.id}`} value={e.id}>
                          {e.first_name} {e.last_name}
                        </option>
                      );
                    })}
              </Form.Select>
            </Col>
          </Form.Group>
        </Col>
        <Col xs={12} md={5} className="justify-content-center pe-4">
          <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
            <Form.Label column xs="5" className="text-9">
              Tipologia Impianto (*)
            </Form.Label>
            <Col xs="7" className="ps-4">
              <Dropdown>
                <Dropdown.Toggle
                  disabled={isLoading || isSubmitting}
                  className="bg-blue fg-white"
                  variant="orange"
                  id="condominium-systemtype-dropdown"
                >
                  <span className="text-10" style={{ textWrap: "balance" }}>
                    {condominiumSystemsText}
                  </span>
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  {systemTypeList?.map((e) => {
                    return (
                      <Dropdown.Item
                        href="#"
                        key={`systype-${e.id}`}
                        value={e.id}
                        onClick={() => toggleSystemTypeFromList(e.id)}
                      >
                        {systemTypeField.current.includes(parseInt(e.id)) ||
                        systemTypeField.current.includes("" + e.id) ? (
                          <i className="mdi mdi-check-circle text-10 fg-green me-1"></i>
                        ) : (
                          ""
                        )}
                        {i18n.t(`models.condominium.system_type.${e.codename}`)}
                      </Dropdown.Item>
                    );
                  })}
                </Dropdown.Menu>
              </Dropdown>
            </Col>
          </Form.Group>
        </Col>
        <Col xs={12} md={5} className="justify-content-center pe-4">
          <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
            <Form.Label column xs="5" className="text-9">
              {i18n.t("models.condominium.fields.time_availability")} (*)
            </Form.Label>
            <Col xs="7">
              <Form.Control
                type="text"
                ref={timeAvailabilityField}
                disabled={isLoading || isSubmitting}
              />
            </Col>
          </Form.Group>
        </Col>
        <Col xs={12} md={6} className="justify-content-center pe-4">
          <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
            <Form.Label column xs="5" className="text-9">
              Referente Condominale (*)
            </Form.Label>
            <Col xs="6">
              <Form.Control
                type="text"
                ref={contactPersonField}
                disabled={isLoading || isSubmitting}
              />
            </Col>
          </Form.Group>
        </Col>
        <Col xs={12} md={5} className="justify-content-center pe-4">
          <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
            <Form.Label column xs="5" className="text-9">
              Terzo Responsabile?
            </Form.Label>
            <Col xs="5" className="ps-4">
              <Form.Select
                ref={thirdpartyResponsableField}
                disabled={isLoading || isSubmitting}
              >
                <option>No</option>
                <option>Si</option>
              </Form.Select>
            </Col>
          </Form.Group>
        </Col>
        <Col xs={12} md={5} className="justify-content-center pe-4">
          <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
            <Form.Label column xs="5" className="text-9">
              Telegestione?
            </Form.Label>
            <Col xs="5" className="ps-4">
              <Form.Select
                ref={hasKeysField}
                disabled={isLoading || isSubmitting}
              >
                <option>No</option>
                <option>Si</option>
              </Form.Select>
            </Col>
          </Form.Group>
        </Col>
        <Col xs={12}>
          <div className="divider-h mb-3 my-1"></div>
        </Col>
        <Col xs={12} md={5} className="justify-content-center pe-4">
          <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
            <Form.Label column xs="4" className="text-9">
              Via e Numero
            </Form.Label>
            <Col xs="8">
              <Form.Control
                type="text"
                ref={addressStreetField}
                disabled={isLoading || isSubmitting}
              />
            </Col>
          </Form.Group>
        </Col>
        <Col xs={12} md={4} className="justify-content-center pe-4">
          <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
            <Form.Label column xs="3" className="text-9">
              CAP
            </Form.Label>
            <Col xs="1"></Col>
            <Col xs="8">
              <Form.Control
                type="text"
                ref={addressPostalCodeField}
                disabled={isLoading || isSubmitting}
              />
            </Col>
          </Form.Group>
        </Col>
        <Col xs={12} md={5} className="justify-content-center pe-4">
          <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
            <Form.Label column xs="4" className="text-9">
              Provincia
            </Form.Label>
            <Col xs="8">
              <Form.Control
                type="text"
                ref={addressProvinceField}
                disabled={isLoading || isSubmitting}
              />
            </Col>
          </Form.Group>
        </Col>
        <Col xs={12} md={4} className="justify-content-center pe-4">
          <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
            <Form.Label column xs="3" className="text-9">
              Comune - Frazione
            </Form.Label>
            <Col xs="1"></Col>
            <Col xs="8">
              <Form.Control
                type="text"
                ref={addressCityField}
                disabled={isLoading || isSubmitting}
              />
            </Col>
          </Form.Group>
        </Col>
        <Col xs={12} md={6} className="justify-content-center pe-4"></Col>
        <Col xs={12}>
          <div className="divider-h mb-3 my-1"></div>
        </Col>
        <Col xs={12} md={5} className="justify-content-center pe-4">
          <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
            <Col xs="12">
              <Form.Group controlId="formFile" className="mb-3 text-9">
                <Form.Label className="text-9">
                  Carica foto dell Condominio
                </Form.Label>
                <Form.Control
                  onChange={handleFotoChange}
                  type="file"
                  accept="image/png, image/jpeg, image/jpg"
                  disabled={isLoading || isSubmitting}
                />
              </Form.Group>
            </Col>
          </Form.Group>
        </Col>
        <Col xs={12} md={5} className="justify-content-center pe-4">
          <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
            <Col xs="12">
              <Form.Group controlId="formFile" className="mb-3">
                <Form.Label className="text-9">Carica PDF</Form.Label>
                <Form.Control
                  onChange={handleFileChange}
                  type="file"
                  accept=".pdf, .doc, .docx"
                  disabled={isLoading || isSubmitting}
                />
              </Form.Group>
            </Col>
          </Form.Group>
        </Col>
        <Col xs={12} md={5} className="justify-content-center pe-4">
          <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
            <Form.Label column xs="2" className="text-9">
              Note
            </Form.Label>
            <Col xs="1"></Col>
            <Col xs="9">
              <Form.Control
                as="textarea"
                rows="3"
                type="text"
                ref={notesField}
                disabled={isLoading || isSubmitting}
              />
            </Col>
          </Form.Group>
        </Col>
        <Col xs={12} className="d-flex justify-content-end align-items-center">
          {!message || message.length === 0 ? (
            ""
          ) : (
            <span className="bg-green fg-white justify-content-center align-items-center px-4 text-9 iminio-border-round-force me-3">
              <i className="mdi mdi-check-circle me-2"></i>
              {message}
            </span>
          )}
          {!error || error.length === 0 ? (
            ""
          ) : (
            <span className="bg-red fg-white justify-content-center px-4 text-9 iminio-border-round-force me-3">
              <i className="mdi mdi-alert-circle me-2"></i>
              {error}
            </span>
          )}
          {!isLoading && !isSubmitting ? (
            ""
          ) : (
            <>
              <span className="me-2">{i18n.t("messages.loading")}</span>
              <i className="mdi mdi-loading mdi-spin text-15 me-2"></i>
            </>
          )}
          <Button
            className={`px-5 corner-round bg-orange fg-white`}
            variant="orange"
            disabled={isLoading || isSubmitting}
            onClick={() => {
              handleSubmit();
            }}
          >
            <i className="mdi mdi-content-save me-2"></i>
            Salva
          </Button>
        </Col>
      </Row>
    </Col>
  );
}

export default CreateCondominiumForm;
